module.exports = __webpack_public_path__ + "images/common/ico-tel_edb7727465a0dfcc3b8b929d3f2617dc.gif";